import pick from 'lodash/pick';
import playerStore from '@player/src/store';
import { PlayerService } from './player';
import { createCurClientVars } from '@src/slide/domain/slide-app/scenes/offline/models/clientVars';

/** 主窗口播放器服务 */
export class MainPlayerService extends PlayerService {
    public static namespace = 'PresenterView';

    public async getClientVars(): Promise<Record<string, any>> {
        return createCurClientVars();
    }

    public getPlayerStore(): Record<string, any> {
        const keyList = ['currentPage', 'currentFragment', 'laserTurnOn', 'iaFragmentInfo'];
        return pick(playerStore.getState().control, keyList);
    }
}
